<div>
    <button
        class="kt-btn kt-btn-ghost kt-btn-icon hover:bg-primary/10 hover:[&_i]:text-primary group size-9 rounded-full">
        <i class="ki-filled ki-magnifier group-hover:text-primary text-lg">
        </i>
    </button>
</div>
